import { TextAsset } from '../PostsListPage/types';
import { Clip } from '@/domains/asset';
import { showErrorToast } from '@/libs/toast/toast';

export function handleClipLockedError(clip: Clip) {
  if (!clip.locked) {
    return;
  }

  const eventId = clip.content.project.id;
  const eventTitle = clip.content.project.title;

  showErrorToast(
    <p className="tw-text-xs">
      <span>{'Clip is published in '}</span>
      <a
        href={`/webinar/${eventId}/details/videos`}
        target="_blank"
        rel="noreferrer"
        className="!text-deep-orange-600 !underline"
      >
        {`${eventTitle}'s`}
      </a>
      <span>{' on-demand page and cannot be edited. Please un-publish to continue editing.'}</span>
    </p>
  );
}

export function handlePostLockedError(post: TextAsset, action: 'edit' | 'delete') {
  if (!post?.locked) {
    return;
  }

  const eventId = post?.content?.project?.id;
  const eventTitle = post?.content?.project?.title;

  showErrorToast(
    <p className="tw-text-xs">
      <span>{'Post is published in '}</span>
      <a
        href={`/webinar/${eventId}/details/videos`}
        target="_blank"
        rel="noreferrer"
        className="!text-deep-orange-600 !underline"
      >
        {`${eventTitle}'s`}
      </a>
      <span>{' on-demand page and cannot be '}</span>
      {action === 'edit' && <span>{'edited. Please un-publish to continue editing.'}</span>}
      {action === 'delete' && <span>{'deleted. Please un-publish to continue deleting.'}</span>}
    </p>
  );
}
